import { Redirect, Route, Router as ReactRouter, Switch } from 'react-router-dom';
import TasksRoute from '../routes/TasksRoute';
import { history } from './history';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Router() {
  return /*#__PURE__*/_jsx(ReactRouter, {
    history: history,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        children: /*#__PURE__*/_jsx(TasksRoute, {})
      }), /*#__PURE__*/_jsx(Redirect, {
        to: "/"
      })]
    })
  });
}